const state = {
  results: [],
  inverseResults: [],
  inverse: false,
  inverseResultsFetched: false,
  operationUsedToCreateResults: null,
  lastFindTaskRequestUrl: null,
  spatialResults: {},
  treeResults: {},
  searchResults: [],
  currentWidgetInResults: null,
  sceneLayerFlag: false,
  selectionMode: null,
  queryUrl: null,
  attributeTableResultsFlag: false,
  attributeTableResults: [],
}

const getters = {
  getInitResults: state => state.results,
  getResults: (state) => {
    if (!state.inverse) {
      return state.results
    }
    return state.inverseResults
  },
  getInverseStatus: state => state.inverse,
  getInverseResultsFetched: state => state.inverseResultsFetched,
  getOperationUsedToCreateResults: state => state.operationUsedToCreateResults,
  getLastFindTaskRequestUrl: state => state.lastFindTaskRequestUrl,
  getSpatialResults: state => state.spatialResults,
  getTreeResults: state => state.treeResults,
  getSearchResults: state => state.searchResults,
  getSceneLayerFlag: state => state.sceneLayerFlag,
  getCurrentWidgetInResults: state => state.currentWidgetInResults,
  getSelectionMode: state => state.selectionMode,
  getQueryUrl: state => state.queryUrl,
  getAttributeTableResultsFlag: state => state.attributeTableResultsFlag,
  getAttributeTableResults: state => state.attributeTableResults,
}

const mutations = {
  setResults: (state, results) => {
    state.results = results
  },
  setInverseResults: (state, results) => {
    state.inverseResults = results
  },
  setOperationUsedToCreateResults: (state, operation) => {
    state.operationUsedToCreateResults = operation
  },
  setLastFindTaskRequestUrl: (state, url) => {
    state.lastFindTaskRequestUrl = url
  },
  setSpatialResults: (state, obj) => {
    state.spatialResults[obj.layerUrl] = obj.results
  },
  setTreeResults: (state, obj) => {
    state.treeResults[obj.layerUrl] = obj.results
  },
  setSearchResults: (state, results) => {
    state.searchResults = results
  },
  setSceneLayerFlag (state, flag) {
    state.sceneLayerFlag = flag
  },
  setCurrentWidgetInResults (state, widgetName) {
    state.currentWidgetInResults = widgetName
  },
  setSelectionMode (state, mode) {
    state.selectionMode = mode
  },
  setQueryUrl (state, url) {
    state.queryUrl = url
  },
  toggleInverse: (state) => {
    state.inverse = !state.inverse
  },
  setInverseResultsFetched (state, flag) {
    if (!flag) state.inverse = false
    state.inverseResultsFetched = flag
  },
  setAttributeTableResultsFlag (state, flag) {
    state.attributeTableResultsFlag = flag
  },
  setAttributeTableResults (state, results) {
    state.attributeTableResults = results
  },
}

const actions = {
  setResults: ({ commit }, results) => {
    commit('setResults', results)
  },
  setInverseResults: ({ commit }, results) => {
    commit('setInverseResults', results)
  },
  toggleInverse: ({ commit }) => {
    commit('toggleInverse')
  },
  setOperationUsedToCreateResults: ({ commit }, operation) => {
    commit('setOperationUsedToCreateResults', operation)
  },
  setLastFindTaskRequestUrl: ({ commit }, url) => {
    commit('setLastFindTaskRequestUrl', url)
  },
  setSpatialResults: ({ commit }, obj) => {
    commit('setSpatialResults', obj)
  },
  setSearchResults: ({ commit }, results) => {
    commit('setSearchResults', results)
  },
  setTreeResults: ({ commit }, results) => {
    commit('setTreeResults', results)
  },
  setSceneLayerFlag ({ commit }, sceneLayerFlag) {
    commit('setSceneLayerFlag', sceneLayerFlag)
  },
  setCurrentWidgetInResults ({ commit }, widgetName) {
    commit('setCurrentWidgetInResults', widgetName)
  },
  changeSelectionMode ({ commit }, mode) {
    commit('setSelectionMode', mode)
  },
  setQueryUrl ({ commit }, url) {
    commit('setQueryUrl', url)
  },
  setInverseResultsFetched ({ commit }, flag) {
    commit('setInverseResultsFetched', flag)
  },
  setAttributeTableResultsFlag ({ commit }, flag) {
    commit('setAttributeTableResultsFlag', flag)
  },
  setAttributeTableResults ({ commit }, results) {
    commit('setAttributeTableResults', results)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
